var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fixed-bottom"},[_c('p',[_vm._v(_vm._s(_vm.userEmail))]),_c('button',{staticClass:"btn text-link  mx-auto",on:{"click":_vm.logout}},[_vm._v(" Logout ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }